import config from '../config.json';

const emptyPillClass = 'ds-header__navbar__nav__link__pill--empty';

export function updateFavoriteRooms(number) {
  const favoritesPill = document.querySelector(config.FAVORITES_SELECTOR);
  if (!favoritesPill) {
    return;
  }
  favoritesPill.innerText = number;
  if (number === 0) {
    favoritesPill.classList.add(emptyPillClass);
  } else {
    favoritesPill.classList.remove(emptyPillClass);
  }
}
